
if(!__webpack_require__.federation){
    __webpack_require__.federation = {
        
chunkMatcher: function(chunkId) {
    return !/^((532|840|861)4|1160|2370|5499)$/.test(chunkId);
},
rootOutputDir: "../../",

    };
}
